import {Component} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {MatError, MatSuffix} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio'
import {SpbAccessibleLinkDirective} from '@sparbanken-syd/sparbanken-syd-theme'
import {InputBaseComponent} from '../0-base/input-base.component'

@Component({
  selector: 'spb-politically-exposed',
  imports: [
    MatRadioGroup,
    FormsModule,
    MatRadioButton,
    MatError,
    SpbAccessibleLinkDirective,
    MatIcon,
    MatSuffix
  ],
  templateUrl: './politically-exposed.component.html',
  styleUrl: './politically-exposed.component.scss'
})
export class PoliticallyExposedComponent extends InputBaseComponent<boolean | null> {
  protected override prop = 'politicallyExposed'
}
